"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectoryTreeview = void 0;
var React = require("react");
var _1 = require(".");
var __1 = require("..");
var DirectoryTreeview_styles_1 = require("./DirectoryTreeview.styles");
var DirectoryTreeview = function (_a) {
    var Data = _a.Data, OnFolderClick = _a.OnFolderClick, OnItemClick = _a.OnItemClick, Selected = _a.Selected;
    var _b = React.useState(), selected = _b[0], setSelected = _b[1];
    React.useEffect(function () {
        setSelected(Selected);
    }, [Selected]);
    var getInternalDataFromData = function (data, parent) {
        var array = [];
        data.forEach(function (item) {
            var internalDataItem = {
                Caption: item.Caption,
                Children: [],
                Folder: item.Folder || !!item.Children,
                HasSelectedChildren: false,
                IsExpanded: Selected === item.UniqueID || item.IsSelected || item.IsExpanded,
                IsSelected: Selected === item.UniqueID || item.IsSelected,
                ParentId: parent ? parent.UniqueID : null,
                UniqueID: item.UniqueID,
            };
            if (item.Children && item.Children.length > 0) {
                item.Children.forEach(function (child) {
                    var _a;
                    return (_a = internalDataItem.Children).push.apply(_a, getInternalDataFromData([child], internalDataItem));
                });
            }
            array.push(internalDataItem);
        });
        return array;
    };
    var checkHasSelectedChildren = function (item) {
        var children = item.Children;
        if (children) {
            for (var i = 0; i < children.length; i++) {
                if (children[i].IsSelected || checkHasSelectedChildren(children[i])) {
                    return true;
                }
            }
        }
        return false;
    };
    var updateHasSelectedChildrenMutator = function (array) {
        for (var i = 0; i < array.length; i++) {
            array[i].HasSelectedChildren = checkHasSelectedChildren(array[i]);
            if (array[i].Children) {
                updateHasSelectedChildrenMutator(array[i].Children);
            }
        }
    };
    var updateHasSelectedChildren = function (array) {
        var clone = __spreadArray([], array);
        updateHasSelectedChildrenMutator(clone);
        return clone;
    };
    var expandWithSelectedChildrenMutator = function (array) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].Folder && array[i].IsExpanded === undefined) {
                array[i].IsExpanded = array[i].HasSelectedChildren;
            }
            if (array[i].Children) {
                expandWithSelectedChildrenMutator(array[i].Children);
            }
        }
    };
    var _c = React.useState([]), mainTreeviewArray = _c[0], setMainTreeviewArray = _c[1];
    React.useEffect(function () {
        var processedArray = updateHasSelectedChildren(getInternalDataFromData(Data, null));
        expandWithSelectedChildrenMutator(processedArray);
        setMainTreeviewArray(processedArray);
    }, [Selected]);
    var onDataRequestHandler = function (item) { return null; };
    var handleOnSelect = function (Item) {
        return new Promise(function (resolve) {
            setSelected(Item.UniqueID);
            resolve();
        });
    };
    return (React.createElement(DirectoryTreeview_styles_1.WrapperDiv, null,
        React.createElement(__1.Treeview, { Data: mainTreeviewArray, FontSize: 14, IndentAmount: 20, RenderFolder: function (node, ref) { return React.createElement(_1.FolderComponent, { ref: ref, Item: node, OnFolderClick: OnFolderClick, OnSelect: handleOnSelect, Selected: selected }); }, RenderItem: function (item, ref) { return React.createElement(_1.FileComponent, { ref: ref, Item: item, OnItemClick: OnItemClick, OnSelect: handleOnSelect, Selected: selected }); }, OnDataRequest: (onDataRequestHandler), SelectedItemID: selected, SpaceAfterGroup: "none", FullWidthFocusStyling: true })));
};
exports.DirectoryTreeview = DirectoryTreeview;
